import React from 'react';
import { SEO } from '../components/SEO/SEO';

export default () => {
  return (
    <div className="container mx-auto py-10">
      <SEO
        title="Calendar"
        description="Events Calendar"
      />
      <h1 className="h1">
        Calendar
      </h1>
      <div className="relative overflow-x-auto">
        <iframe
          src="https://calendar.google.com/calendar/embed?src=ve875mtk6iba0a0u9rpvs4so44%40group.calendar.google.com&ctz=America%2FChicago"
          className="w-full min-w-200"
          height="800"
          frameBorder="0"
          scrolling="no"
        />
      </div>
    </div>
  );
};
